export default __webpack_public_path__ + "static/why-choose-logistics-311b7d7a821784406c321a4eb1a622dd.webp";